/* @flow */

import * as React from 'react';
import {Checkbox} from '../checkbox/checkbox';
import {TextField} from '../textfield';

import './textfield-with-checkbox.css';

type Props = {
    id: string,
    name: string,
    textfieldValue: string,
    onTextfieldChange: (newValue: string) => void,
    placeholder: string,
    isReadOnly?: boolean,
    autoFocus?: boolean,
    hasError?: boolean,
    checkbox?: {
        label: string,
        checked: boolean,
        onChange: () => void,
    },
};

TextfieldWithCheckbox.defaultProps = {
    textfieldValue: '',
};

/* Responsible for rendering a checkbox with a label inside of
of a textfield, floated to the right. When the checkbox is checked
the textfield is automatically disabled. */
export function TextfieldWithCheckbox(props: Props) {
    return (
        <div styleName='textfield-with-checkbox'>
            <TextField
                id={props.id}
                name={props.name}
                autoFocus={props.autoFocus}
                value={props.textfieldValue}
                placeholder={props.placeholder}
                onChange={props.onTextfieldChange}
                disabled={(props.checkbox && props.checkbox.checked) || props.isReadOnly}
                hasError={props.hasError}
            />
            {props.checkbox ? (
                <div styleName='checkbox-container'>
                    <Checkbox
                        name={props.name}
                        isLarge={true}
                        label={props.checkbox.label}
                        onChange={props.checkbox.onChange}
                        checked={props.checkbox.checked}
                        disabled={props.isReadOnly}
                    />
                </div>
            ) : (
                undefined
            )}
        </div>
    );
}
